import { render } from "./Progression.vue?vue&type=template&id=48453625"
import script from "./Progression.vue?vue&type=script&lang=js"
export * from "./Progression.vue?vue&type=script&lang=js"

import exportComponent from "/home/welchome/public_html/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__